import React from "react";
import styled from "styled-components";

import Button from "../../components/Button";
import {
  ContentBlock,
  Image,
  Section,
} from "../../components/shared/layout/Layout";
import Headline from "../../components/shared/text/Headline";
import Subtitle from "../../components/shared/text/Subtitle";
import {
  LargeBodyText,
  MediumHeaderText,
} from "../../components/shared/text/Text";
import { smMedia } from "../../utils/getMediaStyle";

const Box = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 518px;
  margin-bottom: 24px;
  ${smMedia`
    width: 100%;
    padding:24px;
    align-items:center;
  `}
`;
const CompanyLink = styled.a`
  color: ${({ theme }) => theme.color.primary.main};
  text-decoration: underline;
  &:visited,
  :hover {
    color: ${({ theme }) => theme.color.primary.main};
  }
`;
const Title = styled(MediumHeaderText)`
  font-family: cursive;
  font-size: 100px;
  font-weight: bold;
`;
const FeedbackBox = ({
  step,
  title,
  content,
  name,
  company,
  role,
  companyUrl,
  postUrl,
}) => {
  return (
    <Box>
      <div className="d-flex align-items-center">
        <Title className="text-left d-none d-md-inline">{title}</Title>
      </div>
      <LargeBodyText className="mt-2 text-left text-center text-md-left">
        {content}
      </LargeBodyText>
      <Subtitle size={24} className="mt-5">
        {name}
      </Subtitle>
      <Subtitle size={20} color="primary">
        <CompanyLink href={companyUrl} target="_blank">
          {company}
        </CompanyLink>
        , {role}
      </Subtitle>
      <Button
        variation="compact"
        className="col-md-8 mt-4"
        onClick={(e) => {
          e.preventDefault();
          window.location.href = postUrl;
        }}
      >
        Read {name}'s blog post
      </Button>
    </Box>
  );
};

const UserFeedback = (props) => {
  return (
    <ContentBlock className="d-flex flex-column align-items-center" {...props}>
      <Headline className="col-8 col-md-5 text-center">
        Why our users love us
      </Headline>
      <Section className="flex-column-reverse flex-md-row">
        <FeedbackBox
          title='"'
          content="I’m amazed. It's as good as any first draft I've ever written!"
          name="Jenn Sturiale"
          company="PocoPets"
          companyUrl="https://thepocopet.com/"
          role="Founder"
          postUrl="https://thepocopet.com/blogs/news/the-best-warm-small-dog-coats"
        />{" "}
        <Image
          src="https://i.imgur.com/00VuRwG.jpg"
          className="ml-md-5"
          alt="Service workflow"
          title="Workflow"
        />{" "}
      </Section>
      <Section>
        <Image
          src="https:/ /
              i.imgur.com / gahRmV9.jpg "
          className="ml-md-5"
          alt="Service workflow"
          title="Workflow"
        />{" "}
        <FeedbackBox
          title='"'
          content="Copysmith provided an easy solution for a busy start-up founder like myself."
          name="Josh Reding"
          company="MakerBars"
          companyUrl="https://makerbars.com/"
          role="Founder and CEO"
          postUrl="https://makerbars.com/blogs/news/top-5-reasons-why-oats-are-good-for-you"
        />{" "}
      </Section>
      <Section className="flex-column-reverse flex-md-row">
        <FeedbackBox
          title='"'
          content="Copysmith is an easy and quick way to get out a good post."
          name="Alison"
          company="Ease Living"
          companyUrl="https:/ /
          www.easeliving.com / "
          role="Founder/CEO"
          postUrl="https://www.easeliving.com/blogs/news/what-does-mmhg-stand-for"
        />
        <Image
          src="https://i.imgur.com/XC3sQtE.jpg"
          className="ml-md-5"
          alt="Service workflow"
          title="Workflow"
        />
      </Section>
    </ContentBlock>
  );
};

export default UserFeedback;
